import DropdownMenuItem from "ds/components/DropdownMenu/Item";
import { Action, WorkerPool } from "types/generated";
import { checkAllowedAction } from "utils/access";

type WorkerPoolDeleteActionProps = {
  onAction: () => void;
  workerPool: WorkerPool;
};

const hasUsersTooltip = (
  <>
    Before you delete the worker pool, you must make sure it is not used by any stacks or modules.
  </>
);

const hasBusyWorkersTooltip = (
  <>
    Some workers are currently busy running jobs. Wait for the jobs to finish before proceeding.
  </>
);

const WorkerPoolDeleteAction = ({
  onAction,
  workerPool,
}: WorkerPoolDeleteActionProps) => {
  const accessResult = checkAllowedAction(workerPool, Action.WorkerPoolDelete);
  const hasUsers = workerPool.usersCount > 0;
  const hasBusyWorkers = workerPool.busyWorkers > 0;

  const getTooltip = () => {
    if (!accessResult.result) {
      return accessResult.message;
    }
    if (hasBusyWorkers) {
      return hasBusyWorkersTooltip;
    }
    if (hasUsers) {
      return hasUsersTooltip;
    }
    return null;
  };

  const isDisabled = !accessResult.result || hasBusyWorkers || hasUsers;
  const tooltip = getTooltip();

  return (
    <DropdownMenuItem
      tooltip={tooltip}
      isTooltipActive={!!tooltip}
      tooltipWidthMode="maxWidthSm"
      tooltipPlacement="left"
      onAction={onAction}
      danger
      isDisabled={isDisabled}
    >
      Delete
    </DropdownMenuItem>
  );
};

export default WorkerPoolDeleteAction;
